"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelationshipAttr = isRelationshipAttr;
function isRelationshipAttr(attr) {
    return attr?.value.valueType === 'relationship';
}
//# sourceMappingURL=relationship.guard.js.map